// const baseUrl = process.env.REACT_APP_BASE_URL
const accountsUrl = "./accounts";
const userUrl = "./user";
const caseUrl = "./case";
//My Profile.js
export const getPrimaryAccountDetails = accountsUrl + "/accounts";
export const patchEditPhoneEmail = accountsUrl + "/accountphoneemail";
export const patchBillingAddress = accountsUrl + "/billingaddress";

//PrimaryAccount.js
export const getAccountContact = accountsUrl + "/fetchcontacts";
export const getAccountContactDetails = accountsUrl + "/fetchcontactdetails";
export const postNewContact = accountsUrl + "/accountcontacts";
export const patchExistingContact = accountsUrl + "/accountcontacts/update";
export const deleteContact = accountsUrl + "/accountcontacts/";
export const patchAccountContactsInvoice = accountsUrl + "/accountcontactsinvoice";

//ContractAccount.js
export const getContractAccount = accountsUrl + "/contractaccounts";
export const getContractInvoicePreference = accountsUrl + "/invoicepreference";
export const patchContractInvoicePreference = accountsUrl + "/invoicepreference/update";

export const getValidateContractUrl = (accountNumber, contractNumber, userId) => userUrl + "/validaterevealuser";
export const getContractNumbersUrl = (universalAccountId) => accountsUrl + "/contractaccountdetails";
export const getPaymentStatusUrl = accountsUrl + "/checkpaymentstatus";
//Manage Invoice Preference

export const fetchInvoicePreference = accountsUrl + "/fetchinvoicepreference";
export const createNewContact = accountsUrl + "/createnewcontact";
export const updateInvoicePreference = accountsUrl + "/editinvoicepreference";

export const autoPayCheck = accountsUrl + "/autopaycheck";

export const updatePaymentStatus = () => accountsUrl + "/updatepaymentstatus";
